module.exports = __webpack_public_path__ + "fonts/OpenSans-Italic.96e7495a.woff2";